<template>
  <div class="content">
    <h2>Site Archive</h2>
    <hr />
    The Pain Medics website has been deprecated due to pending closure of the
    practice.
    <br /><br />
    This archive contains the old site content for preservation/reference. The
    site archive is for historical purposes only and any information therein may
    be out of date.
    <br />
    <br />
    <ul>
      <li>
        <router-link to="/aboutUs">
          About Us
        </router-link>
      </li>
      <li>
        <router-link to="/team">
          The Team
        </router-link>
      </li>
      <li>
        <router-link to="/patientEducation">
          Patient Education
        </router-link>
      </li>
      <li>
        <router-link to="/forms">
          Forms
        </router-link>
      </li>
      <li>
        <router-link to="/faqs">
          FAQs
        </router-link>
      </li>
      <li>
        <router-link to="/directions">
          Directions/Map
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Archive"
};
</script>

<style scoped>
.content {
  font-size: 1.2vw;
}

h4 {
  font-size: 1.5vw;
  padding-bottom: 0;
  margin-bottom: 0;
}

small {
  padding-top: 0;
  margin-top: 0;
  font-size: 1vw;
}

.image {
  height: 35%;
  width: 35%;
  float: left;
  text-align: center;
}

img {
  max-width: 100%;
}

.vertical-spacer {
  width: 3.5%;
  display: block;
  height: auto;
  float: left;
}

#content-1 {
  width: 60%;
  float: right;
}

#content-2 {
  width: 100%;
  float: left;
  margin-top: 2vw;
}

.horizontal-spacer {
  height: 1.5em;
  width: 100%;
  float: left;
}
</style>
